<template>
  <cc-search-overlay
    v-model="productName"
    placeholder="请输入通用名/商品名"
    v-bind="$attrs"
    v-on="$listeners"
    @cacel="cancel"
    @search="search()"
     >
    <van-list
      class="goods-list"
      @click.stop
      v-show="request"
      :style="{background:bgColor}"
      v-model="m_loading"
      :finished="m_finished"
      :finished-text="m_finishedText"
      @load="mHandlePullUpLoadMore"
      :immediate-check="m_immediateCheck"
    >
      <not-goods  v-if="request && list.length === 0 && m_loading === false"/>
      <goods-item
        v-for="(item,index) in list"
        :item="item"
        :key="index"
      >
      </goods-item>
    </van-list>
  </cc-search-overlay>
</template>

<script>
import { loadMedicareData } from '../../../fetch/home/medicare'
import ListMixin from '@/mixins/list'
import GoodsItem from './item'
import NotGoods from '../components/not-goods'
export default {
  name: 'search-overlay',
  mixins: [ListMixin],
  components: {
    NotGoods,
    GoodsItem
  },
  data () {
    return {
      productName: '',
      list: [],
      ad: null,
      request: false
    }
  },
  computed: {
    bgColor () {
      if (this.ad) {
        return `#${this.ad.background_color}`
      }
      return `#f5f5f5`
    }
  },
  methods: {
    cancel () {
      this.productName = ''
      this.request = false
      this.list = []
    },
    search () {
      this.m_page.curr = 1
      this.m_loading = false
      this.m_finishedText = ''
      this.list = []
      this.loadData()
    },
    async loadData () {
      this.mRequest()
      const params = {
        page: this.m_page.curr,
        page_size: this.m_page.limit,
        second_keyword: this.productName
      }
      let res = await loadMedicareData(params)
      this.$tips(res, {
        tip: false
      }, res => {
        const data = res
        this.ad = data.ad
        this.request = true
        if (data.models.length === 0) {
          this.mEnd()
          if (this.list.length === 0) {
            this.m_finishedText = ''
          }
        } else {
          this.list = [...this.list, ...data.models]
        }
      })
      this.mSuccess()
    }
  }
}
</script>

<style scoped lang="scss">
  .goods-list{
    padding: 10px;
    height: 100%;
    box-sizing: border-box;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch
  }
</style>
